module.exports = __webpack_public_path__ + "assets/mdm.59e15e9c.svg";